/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/421-flickr2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12.5 6.5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0-1.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zM0 8.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0z"/>'
  }
})
